import { io } from "socket.io-client";

const CONNECTION_STRING =
  window.location.protocol + "//" + window.location.host;

let openSocket;

const instantiateOpenConnection = () => {
  openSocket = io(CONNECTION_STRING, {
    path: "/open-socket",
  });
  return openSocket;
};

export const closeOpenConnection = () => {
  if (openSocket) openSocket.disconnect();
};

export const getOpenSocketInstance = () => {
  if (!openSocket) return instantiateOpenConnection();
  return openSocket;
};
